import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import CardlessEMIDetails from './CardlessEMIDetails';
import {
  EMI_TYPE_LOW_COST_EMI_NAME,
  EMI_TYPE_NO_COST_EMI_NAME,
  EMI_TYPE_STANDARD_COST_EMI_NAME,
} from '../../../Constants/EMITypeConstants';
import MerchantPaymentDataUtils from '../../../utils/MerchantPaymentDataUtils';
import downloadIcon from "../../../images/icons/download-icon.svg"
import { SetPaymentAmount } from "../../../stores/actions/PaymentModeAction";
import { useDispatch } from 'react-redux';
import { formatNumber } from '../../Common/Function';

const CardlessEMITenure = (props) => {
  const [showEMIDetails, setShowEMIDetails] = useState(false);
  const {
    tenure,
    selectedTenure,
    setselectedTenure,
    onTenureProceed = false,
    showTenures = false,
    merchantPaymentData,
    bankData
  } = props;

  const dispatch = useDispatch();

  const [keyfactUrl, setKeyfactUrl] =useState("");

  useEffect(() => {
    const url =  process.env.REACT_APP_PG_CONTROLLER +
    "PinePGRedirect/DownloadKeyFactStatementforICICICardless?iIssuerId=" +
    bankData?.issuer_id +
    "&Tenure=" + tenure.tenure_id + 
    "&LoanAmount=" + (tenure?.loan_amount / 100 || 0) + 
    "&TotalInterestCharge=" + (tenure?.interest_pay_to_bank / 100 || "") + 
    "&PaymentMode=19" + "&EMIAmount=" + (tenure?.monthly_installment / 100 || "") +
    "&InterestRate=" + (tenure?.interest_rate
      ? tenure?.interest_rate
      : tenure?.bank_interest_rate / 10000) + 
    "&TotalAmount=" + (props?.merchantPaymentData?.payment_data?.amount_in_paisa / 100 || 0);

    setKeyfactUrl(url)
  },[tenure])

  const onHandleSelect = (tenure) => {
    setselectedTenure(tenure);
    dispatch(SetPaymentAmount(tenure?.auth_amount));
  };

  const getDiscountOrCashbackText = () => {
    let text = '';

    if (tenure?.tenure_id === 96) {
      text = tenure?.offer_scheme?.product_details[0].additional_cashback;
    } else {
      const discountCashBackAmount =
        tenure?.total_offerred_discount_cashback_amount / 100;
      const objMerchantPaymentDataUtils = new MerchantPaymentDataUtils();
      const originalAmount =
        objMerchantPaymentDataUtils?.GetPaymentAmount(merchantPaymentData);
      const emiModelType = merchantPaymentData?.merchant_data?.EMIModelTypeId;

      if (discountCashBackAmount > 0) {
        if (emiModelType === 1) {
          if (
            tenure?.loan_amount === tenure?.auth_amount &&
            tenure?.auth_amount === originalAmount
          ) {
            text = '₹' + discountCashBackAmount + ' post cashback applied';
          } else if (
            tenure?.loan_amount === tenure?.auth_amount &&
            originalAmount - tenure?.auth_amount < formatNumber(discountCashBackAmount * 100)
          ) {
            const psotCashBackValue =
            formatNumber((discountCashBackAmount * 100 -
                (originalAmount - tenure?.auth_amount)) /
              100);
            text = '₹' + psotCashBackValue + ' post cashback applied';
          } else if (tenure?.loan_amount < tenure?.auth_amount) {
            text = '₹' + discountCashBackAmount + ' pre cashback applied';
          } else if (tenure?.loan_amount === tenure?.auth_amount) {
            text = '₹' + discountCashBackAmount + ' instant discount applied';
          }
        } else if (emiModelType === 2) {
          text = '₹' + discountCashBackAmount + ' instant discount applied';
        }
      }

      if (text && text !== '') {
        return <div className='instant-discount'>{text}</div>;
      }
      return text;
    }
  };

  return (
    <>
      {showEMIDetails && (
        <CardlessEMIDetails
          tenure={tenure}
          onCloseClick={setShowEMIDetails}
          showTenures={showTenures}
        />
      )}
      {showTenures ? (
        <div className='col-lg-4 col-md-4 col-sm-6 col-12  mb-3 pr-2'>
          <div
            className={`emi-tenure ${
              selectedTenure?.tenure_id === tenure?.tenure_id ? 'active' : ''
            }`}
          >
            <div className='custom-control custom-radio cardless-emi-radio'>
              <input
                type='radio'
                class='custom-control-input'
                id={tenure?.tenure_id + 'months'}
                value={tenure?.tenure_id}
                name='defaultExampleRadios'
                onClick={() => {
                  onHandleSelect(tenure);
                }}
                onChange={() => {}}
                checked={selectedTenure?.tenure_id === tenure?.tenure_id}
              />
              <label
                class='custom-control-label'
                htmlFor={tenure?.tenure_id + 'months'}
              >
                <span className='pull-left text-left months'>
                  {tenure?.tenure_id === '96'
                    ? 'No EMI Only Cashback'
                    : `${tenure?.tenure_in_month} Months`}
                  <br></br>
                  {tenure?.tenure_id !== '96' ? (
                    <span className='roi'>{`at ${
                      tenure?.interest_rate
                        ? tenure?.interest_rate
                        : tenure?.bank_interest_rate / 10000
                    }% p.a.`}</span>
                  ) : (
                    ''
                  )}
                </span>
                <span className='pull-right text-right amount'>
                  {tenure?.tenure_id !== '96' ? (
                    <>
                      {`₹${
                        tenure?.emi_amount?.amount
                          ? tenure.emi_amount.amount / 100
                          : tenure?.monthly_installment / 100
                      }`}
                      <br></br>
                      <span className='emi-name'>
                        {tenure?.offer_scheme?.product_details[0]
                          ?.subvention_type === 1
                          ? EMI_TYPE_NO_COST_EMI_NAME
                          : tenure?.offer_scheme?.product_details[0]
                              ?.subvention_type === 2
                          ? EMI_TYPE_LOW_COST_EMI_NAME
                          : EMI_TYPE_STANDARD_COST_EMI_NAME}
                      </span>
                    </>
                  ) : (
                    ''
                  )}
                </span>
              </label>
            </div>

            <div className='emi-details-link'>
              {getDiscountOrCashbackText()}
              <NavLink
                to='#'
                href='#collapseemi'
                className='emi-tab  '
                activeClassName='active'
                role='tab'
                aria-controls='nav-home'
                aria-selected='true'
                onClick={() => setShowEMIDetails(true)}
              >
                EMI Details
              </NavLink>
              {[401].includes(bankData.issuer_id || "") &&
              tenure.tenure_id.toString() !== "96" && (
                <a
                  href={keyfactUrl}
                  className='key-fact-cardless'
                >
                  <img src={downloadIcon} alt="d" />
                  <u className='key-facts-cardless-text'> Key fact Statement</u>
                </a>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className='col-lg-4 col-md-4 col-sm-6 col-12  mb-3 pr-2'>
          <div
            className={`emi-tenure ${
              selectedTenure?.tenure === tenure?.tenure ? 'active' : 'disabled'
            }`}
          >
            <div className='custom-control custom-radio cardless-emi-radio'>
              <input
                type='radio'
                class='custom-control-input'
                id={tenure?.tenure + 'months'}
                value={tenure?.tenure}
                name='defaultExampleRadios'
                onClick={() => setselectedTenure(tenure)}
                checked={selectedTenure?.tenure === tenure?.tenure}
              />
              <label
                class='custom-control-label'
                htmlFor={tenure?.tenure + 'months'}
              >
                <span className='pull-left text-left months'>
                  {`${tenure?.tenure} Months`}
                  <br></br>
                  <span className='roi'>{`at ${tenure?.interest_rate}% p.a.`}</span>
                </span>
                <span className='pull-right text-right amount'>
                  {`₹${tenure?.emi_amount?.amount / 100}`}
                  <br></br>
                  <span className='emi-name'>{`${
                    tenure?.no_cost_emi ? '(No cost EMI)' : '(Standard EMI)'
                  }`}</span>
                </span>
              </label>
            </div>

            <div className='emi-details-link pull-left'>
              <NavLink
                to='#'
                href='#collapseemi'
                className='emi-tab  '
                activeClassName='active'
                role='tab'
                aria-controls='nav-home'
                aria-selected='true'
                onClick={() => setShowEMIDetails(true)}
              >
                EMI Details
              </NavLink>
            </div>
            <div className='validate'>
              <button
                className='btn btn-green  btn-small'
                disabled={!(selectedTenure?.tenure === tenure?.tenure)}
                onClick={onTenureProceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardlessEMITenure;
